import { Blockquote, Flex } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonToast } from 'components/common/toast';
import { translateUserErrorMessage } from 'components/sections/admin-portal/machines/dialogs/settings/machine-errors/common';
import { INotification } from 'interfaces/i-notification';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IErrorTypeWithLevel } from 'lib_ts/interfaces/common/i-error-type';
import { useAuthStore } from 'stores/use-auth-store';

interface IProps {
  type?: IErrorTypeWithLevel;
  fallbackError: string;
}

export const ErrorCallout = (props: IProps) => {
  const current = useAuthStore((s) => s.current);

  if (!props.type) {
    return (
      <Blockquote color={RADIX.COLOR.DANGER}>
        This error type does not exist in the database. Please contact
        engineering.
      </Blockquote>
    );
  }

  if (props.type.internal) {
    return (
      <Blockquote color={RADIX.COLOR.WARNING}>
        This is an internal error and will not present the user with any
        notification.
      </Blockquote>
    );
  }

  const config: INotification = {
    hideHeader: true,
    message_md:
      translateUserErrorMessage(props.type, current.language) ||
      props.fallbackError,
    color: NotifyHelper.getColorFromLevel(props.type.level),
    level: props.type.level,
  };

  return (
    <Flex direction="column" gap="1">
      <CommonToast config={config} withoutToast />
    </Flex>
  );
};
